import type { DetailFilter } from "./picture.ts";

const maxStrength = 5;
const maxRadiusRatio = 0.008;
const numDetailValues = 10;

const availableDetailValues = Array.from(
	{ length: numDetailValues },
	(_, i) => {
		const ratio = (i + 1) / numDetailValues;
		return {
			strength: ratio * maxStrength,
			radiusRatio: ratio * maxRadiusRatio,
		};
	},
);

function findClosestDetailFilterValueIndex(value: DetailFilter) {
	const radiusRatioWeight = maxStrength / maxRadiusRatio;
	let minimum:
		| { readonly index: number; readonly difference: number }
		| undefined;
	for (let i = 0; i < availableDetailValues.length; i++) {
		const availableValue = availableDetailValues[i];
		const difference =
			Math.abs(value.strength - availableValue.strength) +
			radiusRatioWeight *
				Math.abs(value.radiusRatio - availableValue.radiusRatio);
		if (minimum === undefined || minimum.difference > difference) {
			minimum = {
				difference,
				index: i,
			};
		}
	}

	if (minimum === undefined) {
		throw new Error("Invalid state - no minimum");
	}
	return minimum.index;
}

export { availableDetailValues, findClosestDetailFilterValueIndex };
